import { SelectMark } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../app/_providers/TranslationProvider.client'
import { FilterList } from '../../../../../../../components/atoms/FilterList'
import { useCollectionFiltersContext } from '../containers/CollectionFiltersContext'

import { FilterInputSegment } from './FilterInputSegment'
import {
  Actions,
  ActionsWrap,
  ApplyButton,
  Body,
  CloseWrap,
  FilterBody,
  FilterInputWrap,
  Headline,
  ResetButton,
  TopActions,
  TopBar,
} from './styles'

export const FilterModalContent: React.FC<{
  clearAllFilters: () => void
  closeFilterModal: () => void
  selectedFilters: Record<string, string[]>
  totalNumberOfSelectedFilterValues: number
}> = ({
  clearAllFilters,
  closeFilterModal,
  selectedFilters,
  totalNumberOfSelectedFilterValues,
}) => {
  const {
    collections: {
      filtering: { filterModal: strings },
    },
  } = useTranslation()

  const defaultExpanded = ['color', 'size']
  const { totalItemsCount, filters } = useCollectionFiltersContext()

  return (
    <Body>
      <FilterBody>
        <TopBar>
          <TopActions>
            <Headline asTag='h4' isUppercase={true}>
              {strings.headline}
            </Headline>
            <CloseWrap onClick={closeFilterModal}>
              <SelectMark />
            </CloseWrap>
          </TopActions>
        </TopBar>

        {filters?.map(filter => (
          <FilterInputSegment
            filterCount={filter.values.length}
            key={filter.name}
            label={filter.displayValue}
            isExpandedInitially={defaultExpanded.includes(filter.name)}
            selectedFilterCount={
              selectedFilters[filter.name]?.length ??
              filter.values.filter(o => o.state === 'SELECTED').length
            }
          >
            <FilterInputWrap>
              <FilterList.List count={filter.values.length}>
                {filter.values.map(filterValue =>
                  filterValue.__typename === 'ProductCatalogProductColorFilterValue' ? (
                    <FilterList.ColorItem
                      key={filterValue.value}
                      filterKey={filter.name}
                      filterValue={filterValue}
                      asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                    />
                  ) : (
                    <FilterList.CheckboxItem
                      key={filterValue.value}
                      filterKey={filter.name}
                      filterValue={filterValue}
                      asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                    />
                  )
                )}
              </FilterList.List>
            </FilterInputWrap>
          </FilterInputSegment>
        ))}
      </FilterBody>
      <ActionsWrap>
        <Actions>
          <ResetButton onClick={clearAllFilters} variant='ghost'>
            {strings.clearAllFiltersCta}
          </ResetButton>
          <ApplyButton onClick={closeFilterModal} disabled={totalItemsCount === 0}>
            {totalItemsCount && totalItemsCount > 0
              ? `${strings.viewCtaPrefix} ${totalItemsCount}`
              : totalItemsCount === 0
              ? 0
              : `${strings.viewCtaPrefix} ${strings.ellipsis}`}{' '}
            {strings.viewCtaPostfix}
          </ApplyButton>
        </Actions>
      </ActionsWrap>
    </Body>
  )
}
